import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis',
  standalone: true,
})
export class TextEllipsisPipe implements PipeTransform {
  transform(value: string, maxLength = 100): string {
    if (!value) return value;
    if (value.length <= maxLength) {
      return value;
    }
    return value.substring(0, maxLength) + '...';
  }
}
